import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccountSettings from 'containers/Account/AccountSettings';

const AccountRouter = ({ match }) => (
  <div className="app-wrapper">
    <Switch>
      <Route path={`${match.url}/settings`} component={AccountSettings} />
    </Switch>
  </div>
);

export default AccountRouter;
